/**
 * Authentication Configuration
 *
 * AWS Cognito and Amplify configuration
 */

/**
 * AWS Cognito configuration
 */
export const cognitoConfig = {
  region: import.meta.env.VITE_AWS_REGION || '',
  userPoolId: import.meta.env.VITE_AWS_USER_POOL_ID || '',
  userPoolClientId: import.meta.env.VITE_AWS_CLIENT_ID || '',
};

/**
 * Amplify configuration (compatible with AWS Amplify v6)
 */
export const amplifyConfig = {
  Auth: {
    Cognito: {
      region: cognitoConfig.region,
      userPoolId: cognitoConfig.userPoolId,
      userPoolClientId: cognitoConfig.userPoolClientId,
    },
  },
};

/**
 * Backend API configuration
 */
export const apiConfig = {
  baseUrl: import.meta.env.VITE_APP_BASE_URL || '',
};

/**
 * Validate authentication configuration
 * @throws Error if required config is missing
 */
export function validateAuthConfig(): void {
  const errors: string[] = [];

  if (!cognitoConfig.region) {
    errors.push('Missing VITE_AWS_REGION environment variable');
  }
  if (!cognitoConfig.userPoolId) {
    errors.push('Missing VITE_AWS_USER_POOL_ID environment variable');
  }
  if (!cognitoConfig.userPoolClientId) {
    errors.push('Missing VITE_AWS_CLIENT_ID environment variable');
  }
  if (!apiConfig.baseUrl) {
    errors.push('Missing VITE_APP_BASE_URL environment variable');
  }

  if (errors.length > 0) {
    console.error('Auth configuration errors:', errors);
    throw new Error(`Auth configuration validation failed:\n${errors.join('\n')}`);
  }
}

/**
 * Check if auth is properly configured
 */
export function isAuthConfigured(): boolean {
  return Boolean(
    cognitoConfig.region &&
    cognitoConfig.userPoolId &&
    cognitoConfig.userPoolClientId &&
    apiConfig.baseUrl
  );
}

// Export default for backward compatibility with aws-exports.ts
export default amplifyConfig;